import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { City } from './city.model';
import { CityService } from './city.service';

@Component({
    selector: 'jhi-city-detail',
    templateUrl: './city-detail.component.html'
})
export class CityDetailComponent implements OnInit, OnDestroy {

    city: City;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private cityService: CityService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['city']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load(id) {
        this.cityService.find(id).subscribe(city => {
            this.city = city;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/city/city-detail.component.ts